import { Observable } from 'rxjs';
import { ILicenceService } from './ILicenceService';
import { HttpRequestService } from '../../http-request.service';
import { Injectable } from '@angular/core';
import { UserLicenceDetailsEntity } from 'src/app/shared/models/Licence/UserLicenceDetailsEntity';
import { apiURLs } from '../../../globalcontants';
import { ValidationEntity } from 'src/app/shared/models/Utilities/ValidationEntity';

@Injectable({
    providedIn: 'root'
  })
  export class LicenceService implements ILicenceService {
    constructor(private httpService: HttpRequestService) { }

    GetLicenceStatusSummary(): Observable<any> {

        return this.httpService.GetHttpRequest(apiURLs.LicencingAPI.GetLicenceStatusSummary);

    }
    GetLoggedInUserDetails(tenantId:any): Observable<UserLicenceDetailsEntity[]> {
      let endPoint = apiURLs.LicencingAPI.GetLoggedInUserDetails+'/'+tenantId;
      return this.httpService.postHttpRequest(endPoint,{});

    }
    SuspendUserPost(suspendUserList: UserLicenceDetailsEntity[],tenantId ): Observable<ValidationEntity> {
      let endPoint=apiURLs.LicencingAPI.PostSuspendUser+'?TenantId='+tenantId
      return this.httpService.postHttpRequest(endPoint, suspendUserList);

    }

  SaveUserInformation(userObj: UserLicenceDetailsEntity) {
    return this.httpService.postHttpRequest(apiURLs.LicencingAPI.SaveUserDeviceInformaion, userObj);
  }

  SendActiveUsersList(toMailID: UserLicenceDetailsEntity) {
    return this.httpService.postHttpRequest(apiURLs.LicencingAPI.SendMail, toMailID);
  }
}
